import React from 'react'
import { MerchantLocationsLoader } from 'router/Loaders'
import { ManageIntegrations } from 'components/Integrations/Manage'
import IntegrationModuleLoaders from 'router/Loaders/PartnerDataLoaders'

export const ManageIntegrationsWrapper = () => {
  return (
    <MerchantLocationsLoader>
      {(isParentLoaded) => (
        <IntegrationModuleLoaders isParentLoaded={isParentLoaded}>
          <ManageIntegrations />
        </IntegrationModuleLoaders>
      )}
    </MerchantLocationsLoader>
  )
}
